export function enumValuesToArray(enumToConvert) {
  return Object.keys(enumToConvert)
    .filter((key, value) => {
      return isNaN(Number(key));
    })
    .map(value => {
      return enumToConvert[value];
    });
}
